import { cn } from "../lib/cn";
import type { Tone } from "../status/tone";

const TONE_CLASSES: Record<Tone, { readonly pill: string; readonly dot: string }> = {
  neutral: { pill: "bg-tone-neutral-bg text-tone-neutral-fg", dot: "bg-tone-neutral-dot" },
  progress: { pill: "bg-tone-progress-bg text-tone-progress-fg", dot: "bg-tone-progress-dot" },
  attention: { pill: "bg-tone-attention-bg text-tone-attention-fg", dot: "bg-tone-attention-dot" },
  done: { pill: "bg-tone-done-bg text-tone-done-fg", dot: "bg-tone-done-dot" },
  problem: { pill: "bg-tone-problem-bg text-tone-problem-fg", dot: "bg-tone-problem-dot" },
};

/**
 * A state as a pill: a dot and its label in the tone's colors (docs/design/meridian.md). The tone comes from
 * `statusTone`, never chosen per screen, and the label always says the state, so color is never the only sign.
 */
export function StatusBadge({ tone, label, className }: { tone: Tone; label: string; className?: string }) {
  const classes = TONE_CLASSES[tone];
  return (
    <span
      className={cn(
        "inline-flex h-5 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2 text-caption font-medium",
        classes.pill,
        className,
      )}
    >
      <span aria-hidden="true" className={cn("size-1.5 rounded-full", classes.dot)} />
      {label}
    </span>
  );
}
